import { gql } from '@apollo/client';

export const deletePlcAlarmCode = gql`
  mutation deletePlcAlarmCode($id: String) {
    deletePlcAlarmCode(id: $id)
  }
`;
